import React from "react";
import { Link } from "react-router-dom";
import { TiArrowRight } from "react-icons/ti";

function PortfolioCard({ components }) {
  console.log(components.code);
  
  return (
    <div
      className="p-[15px] shadow-gray-600 shadow-lg hover:shadow-2xl hover:shadow-gray-600 rounded-lg 
    transition-all bg-white ease-in-out duration-300 hover:scale-110 grid grid-cols-1 gap-2"
    >
      <div className=" border rounded-lg overflow-hidden">
        <img src={`${components.image}.png`} alt="" />
      </div>
      <div className="text-center flex flex-col gap-2 justify-between">
        <h1 className="font-semibold">{components.title}</h1>
        <p className=" text-[0.7rem]">{components.description}</p>

        <div className="flex justify-center gap-4">
          <Link
            className="flex items-center text-gray-700 transition-all
          duration-500 text-[0.8rem] p-1 border-2 border-black rounded-lg hover:bg-black hover:text-white 
          "
            target="_blank"
            to={components.code}
          >
            Code
            <span>
              <TiArrowRight />
            </span>
          </Link>
          <Link
            className="flex items-center text-gray-700 transition-all
          duration-200 p-1 border-2 border-black rounded-lg hover:bg-black hover:text-white text-[0.8rem]"
            target="_blank"
            to={components.url}
          >
            Demo{" "}
            <span>
              <TiArrowRight />
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PortfolioCard;
